<div mwlResizable
     [ngClass]="chartClass"
     [enableGhostResize]="true"
     [ghostElementPositioning]="'absolute'"
     [validateResize]="validateResize"
     (resizeStart)="onResizeStart($event)"
     (resizing)="onResize($event)"
     (resizeEnd)="onResizeEnd($event)">
  <div #chartContainer [style.height]="chartHeight"></div>
  <div class="d-flex justify-content-center h6">
    @if (allowResize) {
      <div mwlResizeHandle class="resize-handle my-auto" [resizeEdges]="{ bottom: true }"></div>
    }
    @if (overriddenChartHeight != null) {
      <div>
        <fa-icon [icon]="['far', 'times-circle']" class="ms-2 text-secondary clickable" [title]="'Reset' | messageTranslate"
          (click)="resetHeight()"/>
      </div>
    }
  </div>
</div>
